import { cityNameFromRecord } from './cityDisplay';

/** Production slug'lari; demo/alias id'ler yerine bunlar tercih edilir. */
export const CANONICAL_CITY_IDS = new Set([
  'nicosia',
  'famagusta',
  'iskele',
  'kyrenia',
  'larnaca',
  'lefke',
  'limassol',
  'morphou',
  'paphos',
  'turkey',
]);

/** Demo seed ve eski id'ler -> canonical slug. */
const CITY_ALIAS_TO_CANONICAL = {
  lefkosa: 'nicosia',
  girne: 'kyrenia',
  'seed-app-demo-city-lefkosa': 'nicosia',
  'seed-app-demo-city-girne': 'kyrenia',
};

export const normalizeCityId = (cityId) => {
  if (cityId === undefined || cityId === null || cityId === '') return cityId;
  const key = String(cityId).toLowerCase();
  return CITY_ALIAS_TO_CANONICAL[key] ?? key;
};

const cityLabelKey = (city, locale) => {
  const name = city?.name;
  if (name && typeof name === 'object') {
    return (locale === 'tr' ? name.tr : name.en) || name.en || name.tr || city.id;
  }
  return cityNameFromRecord(city);
};

/**
 * Ayni gorunen ada sahip sehirleri tek secenekte birlestirir (or. nicosia + lefkosa).
 */
export const dedupeCityChoices = (cities, locale = 'en') => {
  if (!cities?.length) return [];

  const byLabel = new Map();

  for (const city of cities) {
    const label = cityLabelKey(city, locale).trim().toLowerCase();
    if (!label) continue;

    const canonicalId = normalizeCityId(city.id);
    const entry = { ...city, id: canonicalId };
    const existing = byLabel.get(label);

    if (!existing) {
      byLabel.set(label, entry);
      continue;
    }

    const existingIsCanonical = CANONICAL_CITY_IDS.has(existing.id);
    const currentIsCanonical = CANONICAL_CITY_IDS.has(canonicalId);
    if (currentIsCanonical && !existingIsCanonical) {
      byLabel.set(label, entry);
    }
  }

  const collatorLocale = locale === 'tr' ? 'tr' : 'en';
  return Array.from(byLabel.values()).sort((a, b) =>
    cityLabelKey(a, locale).localeCompare(cityLabelKey(b, locale), collatorLocale),
  );
};
